import formatDate from 'utils/dateFormater'
import Download from 'components/Invoices/Download'
import { saveAs } from 'file-saver'
import React from 'react'

const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null,
  origin: [],
  security: [],
  selectedOrigin: null,
  selectedSecurity: null,
  startDate: null,
  endDate: null,
  invoices: null
}

export const ACTION_TYPES = {
  INVOICES_ORIGIN_REQUEST: 'INVOICES_ORIGIN_REQUEST',
  INVOICES_ORIGIN_SUCCESS: 'INVOICES_ORIGIN_SUCCESS',
  INVOICES_ORIGIN_ERROR: 'INVOICES_ORIGIN_ERROR',

  INVOICES_SECURITY_REQUEST: 'INVOICES_SECURITY_REQUEST',
  INVOICES_SECURITY_SUCCESS: 'INVOICES_SECURITY_SUCCESS',
  INVOICES_SECURITY_ERROR: 'INVOICES_SECURITY_ERROR',

  INVOICES_SELECT_ORIGIN: 'INVOICES_SELECT_ORIGIN',
  INVOICES_SELECT_SECURITY: 'INVOICES_SELECT_SECURITY',
  INVOICES_START_DATE: 'INVOICES_START_DATE',
  INVOICES_END_DATE: 'INVOICES_END_DATE',

  INVOICES_REQUEST: 'INVOICES_REQUEST',
  INVOICES_SUCCESS: 'INVOICES_SUCCESS',
  INVOICES_ERROR: 'INVOICES_ERROR',

  INVOICES_DOWNLOAD_REQUEST: 'INVOICES_DOWNLOAD_REQUEST',
  INVOICES_DOWNLOAD_SUCCESS: 'INVOICES_DOWNLOAD_SUCCESS',
  INVOICES_DOWNLOAD_ERROR: 'INVOICES_DOWNLOAD_ERROR',

  INVOICES_CLEAR_STORE: 'INVOICES_CLEAR_STORE'
}

const getOriginAccounts = (state, { data }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    data,
    origin: []
  }

  data.forEach(item => {
    newState.origin.push(
      {
        key: item.accountTypeId,
        value: item.description,
        accountTypeId: item.accountTypeId,
        accountType: item.accountType,
        accountNumber: item.accountNumber
      }
    )
  })
  const deposit = newState.origin.filter(item => item.key === 1)[0]
  newState.selectedOrigin = deposit
  return newState
}

const getSecurities = (state, { data: { value } }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    data: value,
    security: []
  }

  value.types.forEach(item => {
    newState.security.push(
      {
        key: item.type,
        value: item.description,
        description: item.description,
        type: item.type
      }
    )
  }
  )

  return newState
}

const getInvoicesList = (state, { data: { value } }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    invoices: {
      properties: [
        {
          key: 'invoiceNumber',
          value: 'Nota'
        },
        {
          key: 'date',
          value: 'Data da Nota'
        },
        {
          key: 'description',
          value: 'Descrição',
          textAlign: 'left'
        },
        {
          key: 'downloadLink',
          value: ''
        }
      ],
      data: []
    }
  }
  newState.invoices.data = value.invoices.map(invoice => ({
    date: formatDate(invoice.date),
    invoiceNumber: invoice.invoiceNumber,
    description: invoice.description,
    downloadLink: <Download
      param={
        {
          invoiceNumber: invoice.invoiceNumber,
          date: formatDate(invoice.date, 'YYYY-MM-DD'),
          invoiceType: state.selectedSecurity.type,
          accountType: state.selectedOrigin.accountTypeId,
          custodyId: invoice.custodyId || null
        }
      }
    />
  }))
  return newState
}

export const getInvoicesOrigin = () => ({ type: ACTION_TYPES.INVOICES_ORIGIN_REQUEST })
export const getInvoicesSecurity = () => ({ type: ACTION_TYPES.INVOICES_SECURITY_REQUEST })
export const setOrigin = payload => ({ type: ACTION_TYPES.INVOICES_SELECT_ORIGIN, payload })
export const setSecurity = payload => ({ type: ACTION_TYPES.INVOICES_SELECT_SECURITY, payload })
export const setStartDate = payload => ({ type: ACTION_TYPES.INVOICES_START_DATE, payload })
export const setEndDate = payload => ({ type: ACTION_TYPES.INVOICES_END_DATE, payload })
export const getInvoices = payload => ({ type: ACTION_TYPES.INVOICES_REQUEST, payload })
export const downloadInvoice = payload => ({
  type: ACTION_TYPES.INVOICES_DOWNLOAD_REQUEST,
  payload
})
export const clearInvoicesStore = () => ({ type: ACTION_TYPES.INVOICES_CLEAR_STORE })

const invoices = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.INVOICES_ORIGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false
      }
    case ACTION_TYPES.INVOICES_ORIGIN_SUCCESS:
      return getOriginAccounts(state, payload)
    case ACTION_TYPES.INVOICES_ORIGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: true,
        data: payload
      }
    case ACTION_TYPES.INVOICES_SECURITY_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.INVOICES_SECURITY_SUCCESS:
      return getSecurities(state, payload)
    case ACTION_TYPES.INVOICES_SECURITY_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: true,
        data: payload
      }
    case ACTION_TYPES.INVOICES_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.INVOICES_SUCCESS:
      return getInvoicesList(state, payload)
    case ACTION_TYPES.INVOICES_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: true,
        invoices: null,
        data: payload
      }
    case ACTION_TYPES.INVOICES_SELECT_ORIGIN:
      return {
        ...state,
        selectedOrigin: payload
      }
    case ACTION_TYPES.INVOICES_SELECT_SECURITY:
      return {
        ...state,
        selectedSecurity: payload
      }
    case ACTION_TYPES.INVOICES_START_DATE:
      return {
        ...state,
        startDate: payload,
        endDate: null
      }
    case ACTION_TYPES.INVOICES_END_DATE:
      return {
        ...state,
        endDate: payload
      }
    case ACTION_TYPES.INVOICES_DOWNLOAD_REQUEST:
      return state
    case ACTION_TYPES.INVOICES_DOWNLOAD_SUCCESS:
      saveAs(new Blob([payload.response.data], { type: payload.format }), payload.fileName)
      return state
    case ACTION_TYPES.INVOICES_DOWNLOAD_ERROR:
      return {
        ...state,
        error: true,
        data: payload
      }
    case ACTION_TYPES.INVOICES_CLEAR_STORE:
      return initialState
    default:
      return state
  }
}

export default invoices
